import React from 'react';
import Spinner from 'Components/Spinner';
import { useGetUserStatsQuery } from 'app/services/user';
import PieChartStats from './PieChartStats';

const COLORS = ['#39BE9D', '#DC3545'];

const ClientsAccountantsStats = () => {
  const { data } = useGetUserStatsQuery();

  if (!data) {
    return (
      <div className="h-48 flex justify-center items-center">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-start">
      {/* Clients Pie Chart */}
      <PieChartStats
        data={[
          { name: 'Active Clients', value: data.active_clients_count },
          { name: 'Inactive Clients', value: data.inactive_clients_count },
        ]}
        total={data.clients_total_count}
        colors={COLORS}
      />

      {/* Accountants Pie Chart */}
      <PieChartStats
        data={[
          { name: 'Active Accountants', value: data.active_accountants_count },
          {
            name: 'Deactivated Accountants',
            value: data.inactive_accountants_count,
          },
        ]}
        total={data.accountants_total_count}
        colors={COLORS}
      />
    </div>
  );
};

export default ClientsAccountantsStats;
